/**
* Asynchronouse Widget Loader Module
* 
* Module used to asynchronously load widgets on the fly.  
* Currently used in conjunction with the AsyncWidgetLoader widget
*/

var SCM = SCM || {};
SCM.SharedWidgets = SCM.SharedWidgets || {};
SCM.SharedWidgets.UserPersonalization = SCM.SharedWidgets.UserPersonalization || {};

SCM.SharedWidgets.AsyncWidgetLoader = (function() {

    const isRendering = 'is-rendering';

    return {
        LoadWidget: loadWidget
    };

    /**
    * Uses the parameters to load a widget asynchronously using AJAX
    *
    * @param {string} elementClass - The CSS class on the DOM element
    * @param {string} elementAttrUrl - The data attribute to retrieve the URL of the AJAX call
    * @param {string} elementAttrParams - The data attribute to retrieve the parameters to be sent to the AJAX call
    */
    function loadWidget(elementClass, elementAttrUrl, elementAttrParams, requestType, domItems) {
        domItems = SCM.SharedWidgets.VisibilityObserver.determineItemsToLoad(domItems, elementClass)
        domItems = domItems.not('.' + isRendering);
        domItems.each(function () {
            // Get the DOM object so that we can write to it after the AJAX call
            var $domObj = $(this);
            // Get the relevant information about the AJAX call to be made
            var dataUrl = $domObj.attr(elementAttrUrl);
            var dataParams = $domObj.attr(elementAttrParams);
            var params = buildParameters(dataParams);
            $domObj.addClass(isRendering);
            $.ajax({
                url: dataUrl,
                data: params,
                type: requestType,
                success: function (html) {
                    var panelWrapper = $domObj.closest('.js-panel-wrapper');

                    // Write to the parent element, which is the AsyncWidgetLoader div
                    $domObj.parent().replaceWith(html);

                    // Standard event dispatch
                    var event = document.createEvent('Event');
                    event.initEvent(elementClass.replace('.', '') + '_LOADED', true, true);
                    window.dispatchEvent(event);

                    // Legacy SCM event dispatch
                    if (SCM && SCM.EventEmitter && typeof SCM.EventEmitter === 'object') {
                        SCM.EventEmitter.publish(elementClass + '_LOADED');
                    }

                    updateSplitScreenTabs(dataUrl, panelWrapper);
                },
                error: function (xmlHttpRequest, textStatus) {
                    if (window.console) {
                        if (xmlHttpRequest.getResponseHeader("Content-Type").includes("application/json")) {
                            try {
                                var err = JSON.parse(xmlHttpRequest.responseText);
                                console.error('error: ' + err);
                            } catch (e) {
                                console.error("Failed to parse JSON:", e);
                            }
                        } else {
                            console.error("Unexpected response format:", xmlHttpRequest.responseText);
                        }
                        console.error('status: ' + textStatus);
                    }
                }
            });
        });
    }

    function buildParameters(dataParams) {
        var parsed = JSON.parse(dataParams);
        var items = parsed.parameters;
        var localParams = parsed.dynamicParameters;

        var localStore;
        if (localParams !== undefined && localParams.localParams !== undefined && localParams.localParams === '[REPLACE_WITH_LOCAL]') {
            localStore = SCM.SharedWidgets.UserPersonalization.GetFromLocalStorage();
            localParams.localParams = localStore;
            items.Items = JSON.stringify(localStore || { Items: [] });
        }
        if (localParams !== undefined && localParams.localParams !== undefined && localParams.localParams === '[REPLACE_WITH_CROSSDOMAIN_LOCAL]'
            && localParams.crossDomainUrl !== undefined) {
            localStore = SCM.SharedWidgets.UserPersonalization.GetFromCrossDomainLocalStorage(localParams.crossDomainUrl);
            localParams.localParams = localStore;
            items.Items = JSON.stringify(localStore || { Items: [] });
        }
        return items;
    }

    function updateSplitScreenTabs(dataUrl, $tabPanel) {
        if (dataUrl.indexOf('AsyncDynamicWidget') > -1) {
            SCM.SplitScreen.removeTabsWithNoContent();
        }
        if (SCM.AuthorLinks && SCM.AuthorLinks.showAuthorInfo)
        {
            var $authorLinks = $tabPanel.find('.js-linked-name');
            SCM.AuthorLinks.showAuthorInfo($authorLinks);
        }
        
    }
})();

jQuery(document).ready(function ($) {
    SCM.SharedWidgets.AsyncWidgetLoader.LoadWidget('.SCM-SharedWidgets-AsyncWidgetLoader', 'data-url', 'data-params', 'POST');
});
